<template>
  <div class="col-12">
    <div :class="classeBotoes">
      <botao-padrao
        v-if="podeExcluir && buscarPermissao('Orcamento', 'Deletar')"
        class="my-2"
        outlined
        color="danger"
        @click="excluirRegistros"
      >
        <v-icon>$mdiTrashCanOutline</v-icon>
        {{ $t('geral.botoes.excluir') }}
      </botao-padrao>

      <botao-padrao
        v-if="!visualizacao"
        @click="abrirModalMensagem"
      >
        {{ $t('modulos.orcamentos.formulario.selecionar_mensagem') }}
      </botao-padrao>
    </div>
    <tabela-padrao-prime-vue
      ref="tabela"
      v-model="tabela.selecionados"
      class="mt-2 tabela-dku2h1498s"
      :colunas="tabela.colunas"
      :dados="form.orcamentoMensagem"
      :mostrar-seletor="buscarPermissao('Orcamento', 'Deletar') && !visualizacao"
      paginacao-em-memoria
      sem-paginacao
      ajustar-altura-linha
      filtro-geral
      :quantidade-itens="tabela.quantidadeItens"
      :por-pagina="tabela.porPagina"
      :pagina-atual="tabela.paginaAtual"
      :filters="filters"
      :global-filters="tabela.colunas.map(c => c.value)"
    >
      <template v-slot:acoes="{ slotProps }">
        <div class="d-flex">
          <dropdown-padrao
            text
            color="secondary"
          >
            <template #botao>
              <v-icon> $dotsVertical </v-icon>
            </template>
            <v-list-item-group style="overflow-y: auto">
              <v-list-item
                v-if="buscarPermissao('Orcamento', 'Visualizar')"
                class="d-flex min-height-drop-item"
                @click="visualizarDescricao(slotProps.data)"
              >
                {{ $t('modulos.orcamentos.botoes.visualizarDescricao') }}
              </v-list-item>
            </v-list-item-group>
          </dropdown-padrao>
        </div>
      </template>
      <template v-slot:descricao="{ slotProps }">
        <div
          class="formatar-mensagem"
        >
          <span>{{ slotProps.data.descricao }}</span>
        </div>
      </template>
    </tabela-padrao-prime-vue>
    <MensagemModal
      ref="modal-mensagem"
      :form="form"
      :mensagens-selecionadas="form.orcamentoMensagem"
      @novaMensagem="novaMensagem"
    />
    <VisualizarMensagemModal
      ref="visualizar-mensagem-modal"
    />
  </div>
</template>
<script>
import VisualizarMensagemModal from './modais/VisualizarMensagemModal.vue';
import MensagemModal from './modais/MensagemModal';
import { FilterMatchMode } from 'primevue/api';
import helpers from '@common/utils/helpers';
import _ from 'lodash'

export default {
  components: {
    MensagemModal,
    VisualizarMensagemModal,
  },
  props: {
    form: {},
    visualizacao: { type: Boolean, default: false },
    mensagemOrcamentoSelecionada: { type: Array, default: () => [] },
  },
  data() {
    return {
      tabela: {
        selecionados: [],
        dados: [],
        colunas: [
          {
            value: 'index',
            text: this.$t('modulos.orcamentos.tabela.sequencia'),
            sortable: true,
          },
          {
            value: 'titulo',
            text: this.$t('modulos.orcamentos.tabela.nome'),
            sortable: true,
          },
          {
            value: 'descricaoClassificacao',
            text: this.$t('modulos.orcamentos.tabela.classificacao'),
            sortable: true,
          },
          {
            value: 'descricao',
            text: this.$t('modulos.orcamentos.tabela.descricao'),
            sortable: true,
          },
        ],
        paginaAtual: 1,
        porPagina: 10,
      },
      filters: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
    };
  },
  computed: {
    podeExcluir: function () {
      return this.tabela.selecionados.length > 0;
    },
    classeBotoes() {
      return [
        'd-flex align-center',
        this.podeExcluir && this.buscarPermissao('Orcamento', 'Deletar')
          ? 'justify-space-between'
          : 'justify-end py-2'
      ];
    },
  },
  methods: {
    excluirRegistros: function () {
      this.confirmarExcluir().then(() => {
        const selecionadosIds = this.tabela.selecionados.map(item => item.id);
        this.form.orcamentoMensagem = this.form.orcamentoMensagem.filter(item => !selecionadosIds.includes(item.id));

        this.tabela.selecionados = [];
      });
    },
    abrirModalMensagem() {
      this.$nextTick(() => {
        this.$refs['modal-mensagem'].abrirModal();
      });
    },
    novaMensagem: function (itens) {
      let dados = _.cloneDeep(this.form.orcamentoMensagem).concat(itens);
      dados = _.uniqBy(dados, 'titulo');
      dados = _.sortBy(dados, ['sequencia']);
      dados.forEach((dado, index) => {
        dado.index = index + 1;
      });
      this.form.orcamentoMensagem = dados;
    },
    buscarPermissao(funcionalidade, funcionalidadeAcao) {
      return helpers.buscarStatePermissoes(
        this,
        funcionalidade,
        funcionalidadeAcao
      );
    },
    visualizarDescricao(mensagem) {
      this.$refs['visualizar-mensagem-modal'].abrirModal(mensagem);
    }
  },
};
</script>
<style>
.formatar-mensagem {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 890px;
  display: inline-block;
}

.tabela-dku2h1498s .p-datatable.p-datatable-sm .p-datatable-tbody>tr>td:nth-child(3) {
  width: 120px;
}

.tabela-dku2h1498s .p-datatable.p-datatable-sm .p-datatable-tbody>tr>td:nth-child(4) {
  width: 500px;
}

.tabela-dku2h1498s .p-datatable.p-datatable-sm .p-datatable-tbody>tr>td:nth-child(5) {
  width: 250px;
}

.tabela-dku2h1498s .p-datatable.p-datatable-sm .p-datatable-tbody>tr>td:nth-child(6) {
  width: 890px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
